<template>
  <div>
    <h2 class="step-name">Deer - Velveting</h2>

    <div class="step-section">
      <radio-input
        label="Supervisory scheme?"
        field-name="deer_supervisory_scheme"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title=""
        comments-field="deer_vetsouth_velveting_discussion"
        points="Sedation, local only, NaturO rings"
      >
        <radio-input
          label="Does VetSouth do your velveting?"
          field-name="deer_vetsouth_velveting"
          :choices="[
            { value: 'Yes', display: 'Yes' },
            { value: 'No', display: 'No' },
          ]"
          :add-comment="true"
        >
        </radio-input>
      </discussion-points>

      <radio-input
        label="Have your yards passed accreditation?"
        field-name="deer_yards_accreditation"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title="How well do the deer run through the yards?"
        comments-field="deer_yards_run_discussion"
        points="Stress, flow, injuries, etc"
      >
      </discussion-points>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'

export default {
  name: 'DeerVelveting',
  mixins: [baseComponent],
}
</script>
